exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointManagementEditPanel_1agVB34GFP-8XyprbEojFO {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_sharePointManagementSearchResult_1kHJNzAb6P3rxQmKyx11di {\n  padding: 10px 0;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointManagementEditPanel": "IA_sharePointManagementEditPanel_1agVB34GFP-8XyprbEojFO",
	"IA_sharePointManagementSearchResult": "IA_sharePointManagementSearchResult_1kHJNzAb6P3rxQmKyx11di"
};